import React from 'react';
import ModalSubmitForm from '../../../components/sarang-modals/modal-submit-form/modal-submit-form';
import ModalConfirm from '../../../components/sarang-modals/modal-confirm/modal-confirm';
import ModalConfirmCreateCuisine from '../../../components/sarang-modals/modal-confirm/modal-confirm-create-cuisine';
import FormChangeDelivery from './form-change-delivery';

export const TransportOrderModals = ({
    buttonOpenAddEditRef,
    buttonOpenConfirmRef,
    buttonOpenConfirmCreateCuisineRef,
    isOpenAddEditDialog,
    closeAddEditDialog,
    herdsman,
    selectedItem,
    handleSubmitChangeDelivery,
    isOpenDeleteDialog,
    isOpenActiveDialog,
    isOpenDeactiveDialog,
    isOpenChangeStatusDialog,
    isOpenAssignToMeDialog,
    isOpenAssignDeliveryDialog,
    isOpenCancelDeliveryDialog,
    closeConfirmDialog,
    handleConfirm,
    isOpenCreateCusineDialog,
    closeConfirmCreateCuisineDialog,
    assignDelivery
}) => {
    return (
        <>
            <button ref={buttonOpenAddEditRef} type="button" className="d-none" data-toggle="modal" data-target="#modalSubmitForm">
                Launch modal add edit
            </button>
            <button ref={buttonOpenConfirmRef} type="button" className="d-none" data-toggle="modal" data-target="#modalConfirm">
                Launch modal confirm
            </button>
            <button ref={buttonOpenConfirmCreateCuisineRef} type="button" className="d-none" data-toggle="modal" data-target="#modalConfirmCreateCuisine">
                Launch modal confirm
            </button>

            <ModalSubmitForm
                title={"Thay đổi người giao"}
                open={isOpenAddEditDialog}
                onClose={closeAddEditDialog}
            >
                <FormChangeDelivery
                    herdsman={herdsman}
                    updateItem={selectedItem}
                    onSubmitChanges={handleSubmitChangeDelivery}
                />
            </ModalSubmitForm>

            <ModalConfirm
                title={"Xác nhận"}
                prompt={
                    isOpenDeleteDialog ? "Ae/Ce có chắc chắn muốn xóa không?" :
                        isOpenActiveDialog ? "Ae/Ce có chắc chắn muốn xác nhận không?" :
                            isOpenDeactiveDialog ? "Ae/Ce có chắc chắn muốn hủy xác nhận không?" :
                                isOpenChangeStatusDialog ? `Ae/Ce có chắc chắn muốn thay đổi trạng thái thành <b>"${selectedItem?.orderStatusNameChange}"</b>?` :
                                    isOpenAssignToMeDialog ? "Ae/Ce có chắc chắn muốn nhận giao đơn hàng này không?" :
                                        isOpenAssignDeliveryDialog ? `Ae/Ce có chắc chắn muốn cho a/c/e <b>"${selectedItem?.herdsmanDeliverName}"</b> giao đơn hàng này không?` :
                                            isOpenCancelDeliveryDialog ? "Ae/Ce có chắc chắn hủy giao đơn hàng này không?" : ""
                }
                open={isOpenDeleteDialog || isOpenActiveDialog || isOpenDeactiveDialog || isOpenChangeStatusDialog || isOpenAssignToMeDialog || isOpenAssignDeliveryDialog || isOpenCancelDeliveryDialog}
                onClose={closeConfirmDialog}
                onConfirm={handleConfirm}
            />

            <ModalConfirmCreateCuisine
                title={"Xác nhận"}
                prompt={
                    isOpenCreateCusineDialog ? "Ae/Ce có muốn đăng ký suất ăn không?" : ""
                }
                open={isOpenCreateCusineDialog}
                onClose={closeConfirmCreateCuisineDialog}
                onConfirm={handleConfirm}
                assignDelivery={assignDelivery}
            />
        </>
    );
};
